// ------------------------------------
// props 輸入需求 :
// props.data : object : { data: array }            (  )
// ------------------------------------


import React, { useEffect, useState } from 'react'
import UiIntegrater from '../littleUIComponent/UiIntegrater';
import Highcharts from 'highcharts';
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../../actions/ApiGo';
import { LogTime } from '../../../../actions/forFrontEnd_Log';
import { useDispatch, useSelector } from 'react-redux';
import HighchartsReact from 'highcharts-react-official';
import HC_more from 'highcharts/highcharts-more';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../../stores/reducer_add';
HC_more(Highcharts);

// 主元件
const HISSEDemo = (props) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    let resident = props.data
    const [fsensorData, setFsensorData] = useState([]);
    const [chartSet1, setChartSet1] = useState({});
    const store_timestamp = useSelector(state => state.store_historyData.timestamp)
    const [totalInterval, setTotalInterval] = useState([]);
    const [startTime, setStartTime] = useState(0);
    // const [endTime, setEndTime] = useState('');
    const [deepTime, setDeepTime] = useState(0);
    const [awakeTime, setAwakeTime] = useState(0);
    const [lightTime, setLightTime] = useState(0);
    const [totalTime, setTotalTime] = useState(0);
    const [hasData, setHasData] = useState(false);
    function secToTime(y) {
        let _time = Math.round(y / 60)
        let _min = _time % 60
        let _hr = parseInt(_time / 60) % 60
        return (
            <>
                {_hr}<span className="font-ml">{t("GLOBAL.UNIT.HOURS")}</span>
                {' '}
                {_min}<span className="font-ml">{t("GLOBAL.UNIT.MINUTE")}</span>
            </>
        )
    }

    useEffect(() => {
        let _d = new Date(store_timestamp)
        let _date_now = new LogTime(_d).getDate()
        let _d1 = new Date(_d.setDate(_d.getDate() - 1))
        let _date_1daysago = new LogTime(_d1).getDate()

        function get_sleep_data(_date_from, _date_to) {
            return ApiGo.getSleepQuality_ByResident(resident.id, _date_from, _date_to)
                .then(res => res.sleep_qualities[0])
        }
        function get_Fsensor_data(_date_from, _date_to) {
            return ApiGo.getFsensor_ByResident(resident.id, _date_from, _date_to)
                .then(res => {
                    dispatch(ADD_RESPONSE_JSON(res));
                    let _str = res.Fsensor.slice(1, -1)
                    let _list = _str.split("], [")
                    return _list.map(res => {
                        let [_one, _two] = res.split(", ")
                        return [parseInt(_two), parseInt(_one)]
                    })
                })
        }
        setHasData(false)
        Promise.all([
            get_Fsensor_data(_date_1daysago, _date_now),
            get_sleep_data(_date_1daysago, _date_now)
        ])
            .then(([fsensorRes, sleepRes]) => {
                setFsensorData(fsensorRes)

                let _tmp_total = sleepRes.total_interval
                let total = []
                setAwakeTime(sleepRes.awake_interval)
                setDeepTime(sleepRes.deep_interval)
                setLightTime((parseInt(sleepRes.total_time) - parseInt(sleepRes.deep_interval)) - parseInt(sleepRes.awake_interval))
                setTotalTime(sleepRes.total_time)
                _tmp_total.split(",").forEach(res => {
                    let [_time, _stage] = res.split("-")
                    if (_stage !== undefined) {
                        _time = parseInt(_time) * 1000 + 28800000
                        total.push([_time, parseInt(_stage)])
                    }
                })
                let _total_final = []
                for (let i in total) {
                    if (i === 0) _total_final.push(total[i])
                    if (total[i] !== total[i - 1]) _total_final.push(total[i])
                    else console.log(total[i])
                }

                setStartTime(total[0][0])
                setTotalInterval(_total_final)
                setHasData(true)
            })
            .catch(err => {
                console.error("Error fetching data:", err)
                setFsensorData([])
                setTotalInterval([])
                setAwakeTime(0)
                setDeepTime(0)
                setLightTime(0)
                setTotalTime(0)
                setHasData(true)
                dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: "hisRec_no_data" }))
            })
    }, [store_timestamp, resident.id]);

    useEffect(() => {
        const labels = [t("HISTORY_RECORD.SLEEP_DEEP"), t("HISTORY_RECORD.SLEEP_LIGHT"), t("HISTORY_RECORD.SLEEP_AWAKE")]
        setChartSet1({
            time: { useUTC: false },
            chart: { type: 'xy', },
            exporting: { enabled: false },
            title: { text: t("HISTORY_RECORD.SLEEP_ANALYSIS") },
            xAxis: { type: 'datetime', min: startTime },
            yAxis: [
                {
                    max: 7000,
                    min: 0,
                    startOnTick: false,
                    endOnTick: false,
                    opposite: true,
                    gridLineColor: 'transparent',
                    title: false,
                    visible: false,
                    // title: { align: 'high', offset: 0, text: 'Values', rotation: 0, y: -10, zIndex:1 }
                },
                {
                    max: 3,
                    min: 0,
                    startOnTick: false,
                    endOnTick: false,
                    // opposite: true,
                    title: false,
                    // title: { align: 'high', offset: 0, text: 'Stage', rotation: 0, y: -10, zIndex:1 },
                    labels: { formatter: function () { return labels[this.pos - 1] } }
                }
            ],
            series: [
                {
                    name: t("HISTORY_RECORD.SLEEP_MOTION"),
                    data: fsensorData,
                    type: "column",
                    yAxis: 0,
                },
                {
                    name: t("HISTORY_RECORD.SLEEP_STATE"),
                    data: totalInterval,
                    type: "line",
                    step: "left",
                    yAxis: 1
                }
            ]
        })
    }, [hasData])
    return (<>
        <UiIntegrater
            OnOff_switch={[true, false, false, true, true]}
            date={new Date()}
            name={(props.data !== undefined) ? props.data.last_name : ""}
            bed={(props.data !== undefined) ? props.data.first_name : ""}
        />
        {/* <TestSE date={store_timestamp}/> */}
        <div className="fx-d-c w-100 h-100 outer-chart-frame hisChart">
            <HighchartsReact
                highcharts={Highcharts}
                options={chartSet1}
                allowChartUpdate={true}
                containerProps={{ className: "w-100 h-50 chart-frame" }}
            />
            <div className='fx-d-r fx-cspar w-100 SEBack pad-10 t b'>
                <div>{t("HISTORY_RECORD.SLEEP_INFO")}</div>
                <div className='fx-d-c fx-ccc'>
                    <div className='font-l'>{secToTime(totalTime)}</div>
                    <div>{t("HISTORY_RECORD.SLEEP_TOTAL_TIME")}</div>
                </div>
                <div className='fx-d-c fx-ccc'>
                    <div className='font-l'>{secToTime(awakeTime)}</div>
                    <div>{t("HISTORY_RECORD.SLEEP_WAKE_TIME")}</div>
                </div>
                <div className='fx-d-c fx-ccc'>
                    <div className='font-l'>{secToTime(lightTime)}</div>
                    <div>{t("HISTORY_RECORD.SLEEP_LIGHT_TIME")}</div>
                </div>
                <div className='fx-d-c fx-ccc'>
                    <div className='font-l'>{secToTime(deepTime)}</div>
                    <div>{t("HISTORY_RECORD.SLEEP_DEEP_TIME")}</div>
                </div>
            </div>
        </div>

    </>);
}
export default HISSEDemo;